import React, { Fragment } from 'react';
import { func, instanceOf } from 'prop-types';
import classnames from 'classnames';
import { defineMessages, FormattedMessage } from 'react-intl';
import Datetime from './datetime';

const messages = defineMessages({
  from: {
    id: 'datetime.range.from',
    defaultMessage: 'From',
  },
  to: {
    id: 'datetime.range.to',
    defaultMessage: 'To',
  },
  apply: {
    id: 'datetime.range.apply',
    defaultMessage: 'Apply',
  },
});

class DatetimeRange extends React.PureComponent {
  constructor(props) {
    super(props);

    this.updatePeriod = this.updatePeriod.bind(this);
  }

  updatePeriod(propName) {
    return (value) => {
      const { from, to } = { ...this.props, [propName]: value };
      this.props.onChange({ from, to });
    };
  }

  render() {
    const {
      min,
      max,
      to,
      from,
      className,
    } = this.props;

    return (
      <Fragment>
        <Datetime
          onChange={this.updatePeriod('from')}
          min={min}
          max={to}
          value={from}
          className={classnames('mdc-input-datetime-range', className)}
          label={<FormattedMessage {...messages.from} />}
        />
        <Datetime
          onChange={this.updatePeriod('to')}
          min={from}
          max={max}
          value={to}
          className={classnames('mdc-input-datetime-range', className)}
          label={<FormattedMessage {...messages.to} />}
        />
      </Fragment>
    );
  }
}

DatetimeRange.propTypes = {
  onUpdatePeriod: func,
  to: instanceOf(Date).isRequired,
  from: instanceOf(Date).isRequired,
  min: instanceOf(Date),
  max: instanceOf(Date),
};

DatetimeRange.defaultProps = {
  onUpdatePeriod: () => null,
  min: undefined,
  max: undefined,
};

export default DatetimeRange;
